export enum TwofaFlow {
  Setup = 'SETUP',
  Verification = 'VERIFICATION',
  Recovery = 'RECOVERY',
  Reconfiguration = 'RECONFIGURATION',
}
